import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme, withStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Link, useMediaQuery, Box } from '@material-ui/core';

import { Button } from '@lc/legacy/src/Components';
import moment from 'moment';
import { booking, url, scroll } from 'helpers';
import fromEntries from 'helpers/fromentries';
import { useSnackbar } from 'contexts';

import BackButton from 'components/BackButton';
import MyPeriodSelection from './components/MyPeriodSelection';
import ListPeriodHorizontal from './components/ListPeriodHorizontal';

import BookingFinish from './components/BookingFinish';
import BookingSummary from './components/BookingSummary';
import PeriodDaySelector from './components/PeriodDaySelector';
import EPeriodType from '@lc/legacy/src/enum/EPeriodType';

const PeriodSelection = ({
  classes,
  data,
  items,
  period,
  setFinish,
  finish,
  onSelectMore,
  onClose,
}) => {
  const { t } = useTranslation(['booking', 'translations']);
  const [, setMessage] = useSnackbar();
  const now = moment()
    .format('YYYY-MM-DD');
  const [{ periods }] = items;
  const selectedDay = moment(period).format('YYYY-MM-DD');

  const itemsAvailability = Object.entries(periods).filter(
    item => item[0] >= now && item[1].length > 0,
  );
  const indexCalendar = itemsAvailability.findIndex(idx => idx[0] === selectedDay);

  const [activeStep, setActiveStep] = useState(indexCalendar < 0 ? 0 : indexCalendar);
  const [dates, setDates] = useState(fromEntries(itemsAvailability.map(item => [item[0], []])));

  const [checkeds, setChecked] = useState({});
  const [current, setCurrent] = useState({
    name: itemsAvailability[activeStep][0],
    value: itemsAvailability[activeStep][1],
  });
  const [mySelections, setMySelections] = useState(false);
  const [showMyPeriods, setShowMyPeriods] = useState(false);
  const [showMyPeriodsPrice, setShowMyPeriodsPrice] = useState(false);
  const [showMyPeriodsPriceInner, setShowMyPeriodsPriceInner] = useState(false);
  const [showMySelectionsInner, setShowMySelectionsInner] = useState(false);
  const [editingPeriodDay, setEditingPeriodDay] = useState(false);
  const [showMyPeriodsFinish, setShowMyPeriodsFinish] = useState(false);
  const theme = useTheme();
  const xsSize = useMediaQuery(theme.breakpoints.down('xs'));

  const sizeof = itemsAvailability.length - 1;

  const setInSession = () => {
    const filterDts = Object.keys(dates)
      .filter(key => dates[key].length)
      .reduce((res, key) => Object.assign(res, { [key]: dates[key].sort() }), {});

    if (Object.keys(filterDts).length) booking.setPeriods(data.id, filterDts);
  };

  const handleNext = () => {
    if (activeStep < sizeof) {
      setActiveStep(prevActiveStep => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep(prevActiveStep => prevActiveStep - 1);
    }
  };

  const setSelected = (payload, bool) => {
    const [key, value] = payload.split('@');
    const dats = { ...dates };
    const keyDats = Object.keys(dates);
    const sessionDats = Object.keys(booking.getPeriods(data.id) || []);

    const toRemove = keyDats.filter(i => !sessionDats.includes(i));
    toRemove.forEach(el => {
      if (dats[el].length) delete dats[el];
    });

    Object.keys(dats).forEach(chave => {
      const equalKey = key === chave;
      if (equalKey && bool && !dats[key].includes(value)) {
        dats[key].push(value);
      } else if (equalKey && !bool) {
        const idx = dats[key].indexOf(value);
        dats[key].splice(idx, 1);
      }
    });

    setDates(dats);
  };

  const setCheckedStatus = event => {
    setChecked({ ...checkeds, ...{ [event.target.name]: event.target.checked } });
    setSelected(event.target.name, event.target.checked);
  };

  useEffect(() => {
    if (showMyPeriodsFinish) {
      setFinish(false);
    }
  }, [showMyPeriodsFinish]);

  useEffect(() => {
    setCurrent({
      name: itemsAvailability[activeStep][0],
      value: itemsAvailability[activeStep][1],
    });
  }, [activeStep]);

  useEffect(() => {
    setInSession();

    const chs = {};
    const filterDts = Object.keys(dates)
      .filter(key => dates[key].length)
      .reduce((res, key) => Object.assign(res, { [key]: dates[key] }), {});

    Object.entries(filterDts).forEach(([key, times]) => {
      times.forEach(time => {
        chs[`${key}@${time}`] = true;
      });
    });
    setChecked({ ...checkeds, ...chs });
    if (Object.keys(filterDts).length) {
      if(data.period_type === EPeriodType.HOURS){
        if(Object.keys(chs).length < data.min_hours){
          setMySelections(false);
          setMessage({ message: `Este anúncio requer reserva mínima de ${data.min_hours}h`, variant: 'warning'});
        }else{
          setMySelections(true);
          setMessage({ close: true });
        }
      }else{
        setMySelections(true);
      }

    } else {
      setMySelections(false);
    }
  }, [dates]);

  useEffect(() => {
    const dts = { ...dates };
    const reservDts = booking.getPeriods(data.id);
    if (reservDts) {
      Object.keys(dts).forEach(key => {
        dts[key] = reservDts[key] || [];
      });
    }
    setDates(dts);
  }, []);
  if (
    booking.getPeriods(data.id) &&
    Object.keys(booking.getPeriods(data.id)).length === 0 &&
    mySelections
  ) {
    setMySelections(false);
  }

  return (
    <>
      {!showMyPeriodsPrice && (
        <BackButton
          noPadding
          onClick={() => {
            if (showMyPeriodsFinish) {
              if (editingPeriodDay) {
                setEditingPeriodDay(undefined);
              } else {
                setShowMyPeriodsFinish(false);
                setFinish(true);
              }
            } else if (showMySelectionsInner) {
              setShowMySelectionsInner(false);
            } else if (editingPeriodDay) {
              setEditingPeriodDay(undefined);
            } else if (showMyPeriods) {
              setShowMyPeriods(false);
            } else {
              url.removeFromQueryString('review');
              setTimeout(() => {
                scroll.to(`#calendar`);
              }, 500);
              onClose();
            }
          }}
        />
      )}
      {showMyPeriodsPrice && (
        <BackButton
          noPadding
          onClick={() => {
            if (!showMyPeriodsPriceInner) {
              setShowMyPeriods(false);
              setShowMyPeriodsPrice(false);
            } else {
              setShowMyPeriodsPrice(false);
            }
          }}
        />
      )}

      <div className={classes.main}>
        {finish && (
          <BookingFinish
            onClose={onClose}
            data={data}
            setShowMyPeriodsFinish={setShowMyPeriodsFinish}
          />
        )}
        {showMyPeriodsPrice && (
          <div style={{ marginTop: '20px' }}>
            <Typography variant="body2" color="secondary">
              <b>{t('myPeriods')}</b>
            </Typography>
            <Typography
              variant="overline"
              style={{ textTransform: 'initial', fontWeight: 'normal' }}
            >
              {t('untilNowYoullPay')}
            </Typography>
            <div style={{ marginTop: '40px' }}>
              <BookingSummary data={data} />
            </div>
          </div>
        )}
        {(showMyPeriodsFinish || (!finish && showMyPeriods && !showMyPeriodsPrice)) && (
          <MyPeriodSelection
            hidePeriod={showMyPeriodsFinish}
            data={data}
            itemsAvailability={itemsAvailability}
            setActiveStep={setActiveStep}
            activeStep={activeStep}
            mySelections={mySelections}
            onSelectMore={onSelectMore}
            onClose={() => setEditingPeriodDay(undefined)}
            setShowMyPeriodsPrice={() => {
              setShowMyPeriodsPrice(true);
              setShowMyPeriodsPriceInner(true);
            }}
            setEditingPeriodDay={setEditingPeriodDay}
            editingPeriodDay={editingPeriodDay}
            setCurrent={setCurrent}
            checkeds={checkeds}
            setChecked={setChecked}
            PeriodDaySelector={() => (
              <PeriodDaySelector
                hideArrows
                setCheckedStatus={setCheckedStatus}
                checkeds={checkeds}
                current={current}
                min_hours={data.min_hours}
                period_hours={data.period_hours}
                period_type={data.period_type}
                handleBack={handleBack}
                handleNext={handleNext}
                title="Clique no período que deseja alterar da sua reserva."
              />
            )}
          />
        )}
        {!finish && !showMySelectionsInner && !showMyPeriods && !showMyPeriodsFinish && (
          <div style={{ marginTop: '20px' }}>
            <PeriodDaySelector
              setCheckedStatus={setCheckedStatus}
              checkeds={checkeds}
              current={current}
              min_hours={data.min_hours}
              period_hours={data.period_hours}
              period_type={data.period_type}
              handleBack={handleBack}
              handleNext={handleNext}
              title={data.period_type !== EPeriodType.HOURS ? t('periodSelector') : t('hourSelector')}
            />
            <Grid container spacing={0} justify="space-between" style={{ display: 'block' }}>
              {mySelections && (
                <>
                  <Button
                    onClick={() => {
                      setShowMyPeriodsPrice(true);
                      setShowMyPeriods(true);
                    }}
                    size="xs"
                    style={{ padding: 0 }}
                  >
                    <img src="/images/icons/dollar.png" alt="dollar" />
                    <Typography
                      variant="overline"
                      color="textSecondary"
                      style={{ marginLeft: '5px', textTransform: 'initial' }}
                    >
                      {t('myPeriods')}
                    </Typography>
                  </Button>
                  <div style={{ marginTop: '16px' }}>
                    <Typography
                      variant="body2"
                      color="secondary"
                      style={{ textTransform: 'initial' }}
                    >
                      <b>Minhas seleções</b>
                    </Typography>
                    <ListPeriodHorizontal
                      items={booking.getPeriods(data.id)}
                      selectedDay={d => {
                        setActiveStep(itemsAvailability.findIndex(idx => idx[0] === d));
                      }}
                      period_hours={data.period_hours}
                    />
                    <Link
                      color="primary"
                      underline="always"
                      href="#/"
                      onClick={() => setShowMyPeriods(true)}
                      style={{ textTransform: 'initial', fontSize: '10px' }}
                    >
                      Ver detalhes
                    </Link>
                  </div>
                </>
              )}
            </Grid>
          </div>
        )}
        {!finish && !showMyPeriodsFinish && !editingPeriodDay && (
          <Grid
            container
            spacing={0}
            justify={xsSize ? 'space-between' : 'flex-end'}
            style={{ marginTop: '36px' }}
          >
            <Button
              id="btn-choose-more-periods"
              size={xsSize ? 'xs' : 'medium'}
              disabled={!mySelections}
              color="secondary"
              variant="outlined"
              onClick={() => {onSelectMore(); window.scrollTo(0, 0);}}
            >
              {t('chooseMorePeriods')}
            </Button>
            {!xsSize ? <Box ml={2} /> : null}
            <Button
              onClick={() => {
                setFinish(true);
                window.scrollTo(0, 0);
              }}
              id={url.getFromQueryString('type') === 'equipment' ? 'btn-finish-reserve-equipment' : 'btn-finish-reserve'}
              size={xsSize ? 'xs' : 'medium'}
              color="secondary"
              variant="contained"
              disabled={!mySelections}
            >
              {t('finishBooking')}
            </Button>
          </Grid>
        )}
      </div>
    </>
  );
};

PeriodSelection.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  finish: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  // onFinish: PropTypes.func.isRequired,
  onSelectMore: PropTypes.func.isRequired,
  period: PropTypes.instanceOf(Date).isRequired,
  setFinish: PropTypes.func.isRequired,
};

const styles = () => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
});

export default withStyles(styles)(PeriodSelection);
